import React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import { useAllEventDefinitions } from "components/event-definitions/hooks/useEventDefinitions";
import CorrelationForm from "./CorrelationForm";
import EventsLicenseStatus from "./EventsLicenseStatus";
import useEventsLicenseStatus from "./hooks/useEventsLicenseStatus";
const CorrelationFormContainer = (props) => {
  const { t } = useTranslation("enterprise_security");
  const eventsLicenseStatus = useEventsLicenseStatus();
  const { data } = useAllEventDefinitions();
  const eventDefinitions = data == null ? void 0 : data.event_definitions;
  const isLoading = !eventDefinitions || eventsLicenseStatus.loading;
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: t("correlation_form_container.loading_event_definitions") });
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(EventsLicenseStatus, { licenseStatus: eventsLicenseStatus }), /* @__PURE__ */ React.createElement(CorrelationForm, { ...props, eventDefinitions }));
};
export default CorrelationFormContainer;
